import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EstadosRol } from "./entity'estados-rol.models";

@Injectable({
  providedIn: 'root'
})
export class EntityEstadoRolService {
  url: string;
  token: string;
  endpoint = 'tramites';

  constructor(private http: HttpClient) {}

  getEstadosRol(): Observable<EstadosRol[]> {
    return this.http.get<EstadosRol[]>(`${this.url}/estadosRol/`);
  }
}
